import React, { useCallback, useMemo } from 'react';
import { Card, Form, Select } from '../../../../components';

const PUBLIC_IP_OPTIONS = [
    { value: 'none', label: 'None' },
    { value: 'automatic', label: 'Automatic' },
];

const NETWORK_TIER_OPTIONS = [
    { value: 'STANDARD', label: 'Standard' },
    { value: 'PREMIUM', label: 'Premium' },
];

const networkLabel = (network) => {
    if (network.from_project) {
        return `${network.name} (from project: ${network.from_project})`;
    }
    return network.name;
};

const networkFqdn = (network) => {
    if (network.from_project) {
        `projects/${network.from_project}/global/networks/${network.name}`;
    }
    return network.name;
};

export const GCPNetworkConfig = ({ networks = [], disabled = false, title = 'Network Adapter' }) => {
    const form = Form.useFormInstance();
    const selectedNetwork = Form.useWatch('networkName', form);
    const assignPublicIp = Form.useWatch('assignPublicIp', form);

    const networkOptions = useMemo(
        () => networks.map((network) => ({ value: networkFqdn(network), label: networkLabel(network) })),
        [networks],
    );

    const subnetOptions = useMemo(() => {
        const currentNetwork = networks.find((network) => networkFqdn(network) === selectedNetwork);
        return (currentNetwork?.subnets || []).map((subnet) => ({
            value: subnet.name,
            label: `${subnet.name} (${subnet.cidr_block})`,
        }));
    }, [networks, selectedNetwork]);

    const handleNetworkChange = useCallback(() => {
        // A new network has its own subnets, so clear the previous subnet selection.
        form.setFieldsValue({ subnet: undefined });
    }, [form]);

    return (
        <Card title={title} size="small" className="network-config-card network-config-card--appliance">
            <Form.Item name="networkName" label="Network" rules={[{ required: true, message: 'Network is required' }]}>
                <Select
                    placeholder={networks.length === 0 ? 'Select a Region first' : 'Select a Network'}
                    onChange={handleNetworkChange}
                    options={networkOptions}
                    disabled={disabled || networks.length === 0}
                    showSearch={{ optionFilterProp: 'label' }}
                />
            </Form.Item>

            {selectedNetwork && (
                <>
                    <Form.Item name="subnet" label="Subnet" rules={[{ required: true, message: 'Subnet is required' }]}>
                        <Select
                            placeholder="Select a Subnet"
                            options={subnetOptions}
                            disabled={disabled}
                            showSearch={{ optionFilterProp: 'label' }}
                        />
                    </Form.Item>

                    <Form.Item name="assignPublicIp" label="External IP">
                        <Select options={PUBLIC_IP_OPTIONS} disabled={disabled} />
                    </Form.Item>

                    {assignPublicIp === 'automatic' && (
                        <Form.Item
                            name="networkTier"
                            label="Network Tier"
                            rules={[{ required: true, message: 'Network Tier is required' }]}
                        >
                            <Select options={NETWORK_TIER_OPTIONS} disabled={disabled} />
                        </Form.Item>
                    )}
                </>
            )}
        </Card>
    );
};
